import { getAssetsBaseUrl } from './assetsUrl';

const base = () => `${getAssetsBaseUrl()}/images/social-media`;

export const socialMediaIconUrls = {
    instagram: () => `${base()}/instagram.png`,
    facebook: () => `${base()}/facebook.png`,
    youtube: () => `${base()}/youtube.png`,
    tiktok: () => `${base()}/tiktok.png`,
};
